import classNames from "classnames";
import PlusIcon from "PFComponents/icons/plus_icon";
import PropTypes from "prop-types";
import React from "react";

import css from "./add_icon.less";

const AddIcon = ({ className }) => (
  <div className={classNames(css.background, className)}>
    <PlusIcon className={css.icon} size={12} />
  </div>
);

AddIcon.propTypes = {
  className: PropTypes.string
};

export default AddIcon;
